import React, { BaseSyntheticEvent } from 'react'
import { IonButton, IonCol, IonRow } from '@ionic/react'
import { IOption, IOptions } from '../../common/common.types'
import './MultiSelectButtons.component.css'
import useDeviceMetrics from '../../utilities/useDeviceMetrics'
import { deepCopy } from '../../utilities/array.utils'

interface ISelectButtonsProps {
  label?: string
  dataTestId: string
  options: IOptions
  selectAction: (e: BaseSyntheticEvent, selectedOptions: any, dispatchData?: any) => void
  selectedOptions: IOptions
  dispatchData?: any
  color?: string
  buttonValidation?: (selectedOpt: IOptions, currentOpt: IOption) => boolean
}

const MultiSelectButtons: React.FC<ISelectButtonsProps> = (props: ISelectButtonsProps) => {
  const { label, dataTestId, options, selectAction, selectedOptions, dispatchData, color, buttonValidation } = props
  const { isTablet: isTabletDevice } = useDeviceMetrics()

  const updateSelectedOptions = (e: BaseSyntheticEvent, option: IOption) => {
    const newSelectedOptions = deepCopy(selectedOptions)

    if (newSelectedOptions.filter((o) => o.id === option.id).length) {
      newSelectedOptions.splice(
        newSelectedOptions.findIndex((o) => o.id === option.id),
        1
      )
    } else {
      newSelectedOptions.push(option)
    }
    selectAction(e, newSelectedOptions, dispatchData)
  }

  return (
    <>
      <section>
        {label && <header className='multi-select-button-header'>{label}</header>}
        <IonRow>
          {options.map((option) => (
            <IonCol
              key={option.id}
              sizeMd={isTabletDevice ? '4' : '3'}
              sizeXs='4'
              className='multiselect-button-column'>
              <IonButton
                data-testid={dataTestId + option.id}
                id='multiselect-button-button'
                expand='block'
                size={isTabletDevice ? 'default' : 'small'}
                fill={selectedOptions.filter((o) => o.id === option.id).length ? 'solid' : 'outline'}
                color={selectedOptions.filter((o) => o.id === option.id).length ? (color ? color : 'primary') : ''}
                className={
                  (selectedOptions.filter((o) => o.id === option.id).length ? '' : 'clearButton') +
                  (isTabletDevice ? ' tablet-multi-select-button' : '')
                }
                disabled={buttonValidation ? buttonValidation(selectedOptions, option) : false}
                onClick={(e) => updateSelectedOptions(e, option)}>
                {option.name}
              </IonButton>
            </IonCol>
          ))}
        </IonRow>
      </section>
    </>
  )
}
export default MultiSelectButtons
